export default "__VITE_ASSET__522ac292__"